import { fetcher } from '../../configure'
import { PlannedRoute } from './dto/planned-route.dto'

export type DeletePlannedRouteRequest = {
    route: PlannedRoute
}

export type DeletePlannedRouteResponse = {
	success: boolean
}

export type DeletePlannedRouteEndpoint = (
	request: DeletePlannedRouteRequest
) => Promise<DeletePlannedRouteResponse>

export const deletePlannedRouteEndpoint: DeletePlannedRouteEndpoint = async (request) => {
	return await fetcher({
		method: 'post',
		path: `/users/planned-routes/delete`,
		body: request,
	})
}